export default [
    {
        path: '/',
        component: () => import('@/layout/main.vue'),
        children: [
            {
                path: '',
                name: "home",
                meta: {
                    title: "home"
                },
                component: () => import('@/view/index.vue')
            },
            {
                path: 'works',
                name: "works",
                meta: {
                    title: "how it works"
                },
                component: () => import('@/view/works.vue')
            },
            {
                path: 'help',
                name: "help",
                meta: {
                    title: "help"
                },
                component: () => import('@/view/help.vue')
            },
        ]
    },
    // 管理员路由
    {
        path: '/admin/login',
        name: 'adminLogin',
        meta: {
            title: '管理员登录'
        },
        component: () => import('@/view/admin/login.vue')
    },
    {
        path: '/admin/dashboard',
        name: 'adminDashboard',
        meta: {
            title: '管理后台',
            requiresAuth: true
        },
        component: () => import('@/view/admin/dashboard.vue')
    },
    {
        path: '/admin/edit/index',
        name: 'adminEditIndex',
        meta: {
            title: '首页内容编辑',
            requiresAuth: true
        },
        component: () => import('@/view/admin/edit/index.vue')
    },
    {
        path: '/admin/edit/works',
        name: 'adminEditWorks',
        meta: {
            title: '工作原理页面编辑',
            requiresAuth: true
        },
        component: () => import('@/view/admin/edit/works.vue')
    },
    {
        path: '/admin/edit/help',
        name: 'adminEditHelp',
        meta: {
            title: '帮助页面编辑',
            requiresAuth: true
        },
        component: () => import('@/view/admin/edit/help.vue')
    },
    {
        path: '/admin/edit/header',
        name: 'adminEditHeader',
        meta: {
            title: '公共头部编辑',
            requiresAuth: true
        },
        component: () => import('@/view/admin/edit/header.vue')
    },
    {
        path: '/admin/edit/footer',
        name: 'adminEditFooter',
        meta: {
            title: '公共底部编辑',
            requiresAuth: true
        },
        component: () => import('@/view/admin/edit/footer.vue')
    }
]